import type { ReactNode } from 'react'

import { isRollLayout, type LabelLayout } from '@aeris/printing'

import { formatDecimalInput } from '../lib/label-template-draft.ts'

/**
 * O que ajustar no diálogo de impressão do Chrome — F127, completado na F210.
 *
 * "Cabeçalhos e rodapés" marcado imprime a data e o título da página por cima
 * da etiqueta (o dono mandou a foto: "27/09/2026, 22:22" num selo). A página
 * não consegue desmarcar essa opção — só quem imprime. O Chrome lembra a
 * escolha por impressora, então é uma vez só.
 *
 * Numa bobina, o papel também (F264). O Chrome imprime no papel escolhido no
 * driver, e um papel diferente da fileira encolhe e centraliza a página: foi a
 * Zebra da Elite GV soltando a etiqueta 13 mm abaixo e cortada. A página não
 * escolhe o papel; a dica diz qual é.
 */
export const PrintSettingsHint = ({
  layout,
}: {
  /** O modelo escolhido. Sendo bobina, a dica diz o tamanho do papel. */
  layout?: LabelLayout | undefined
}): ReactNode => {
  const roll =
    layout !== undefined && isRollLayout(layout) ? layout.page : undefined

  return (
    <p className="text-(length:--text-xs) text-(--text-muted)">
      Ao imprimir abre o diálogo do sistema:{' '}
      <strong>escolha ali a impressora</strong> e deixe{' '}
      <strong>Margens: Nenhuma</strong> e <strong>Escala: 100</strong>. Em{' '}
      <strong>Mais definições</strong>,{' '}
      {roll === undefined ? null : (
        <>
          escolha{' '}
          <strong>
            Tamanho do papel: {formatDecimalInput(roll.widthMm)} ×{' '}
            {formatDecimalInput(roll.heightMm)} mm
          </strong>{' '}
          — uma fileira, o papel criado no driver da impressora (o Teste da
          bobina, no modelo, confere) — e{' '}
        </>
      )}
      desmarque <strong>Cabeçalhos e rodapés</strong> — senão sai a data e o
      nome da página em cima da etiqueta. O Chrome lembra para a próxima.
    </p>
  )
}
